/* ==========================================================================
   LoadingInformation > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const ImageClient = require('../../../image/client/js');
const prototype = require('./prototype');
const config = require('./config');

/* Utilities functions */
const loadingInStore = instance => instance.getStore().filter(item => item.type === instance.type);
const loadingIsUnique = instance => loadingInStore(instance).length > 0;

/**
 * LoadingInformation component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function LoadingInformation(selector = '[data-component="LoadingInformation"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance to return to other components */
        const instance = Object.create(prototype);

        /* Element reference */
        instance.element = document.querySelector(selector);

        /* Config reference */
        instance.config = { ...config(), ...configuration };

        /* Image reference */
        if (elementExist(`${selector} [data-component="Image"]`)) {
            instance.image = ImageClient(`${selector} [data-component="Image"]`, {
                ...configuration.image
            });
        }

        /* Uniqueness loading */
        if (loadingIsUnique(instance)) {
            /* Remove from dom newly created modal to replace it */
            instance.removeFromDom();

            /* Replace instance with the current in store */
            return loadingInStore(instance).reduce((acc, val) => acc + val);
        }

        /* Init */
        if (instance.config.init) instance.init();

        /* Return the instance */
        return instance;
    }
};
